export default __webpack_public_path__ + "static/media/GothamSSm-Book.dc2582dc.eot";